module.exports = __webpack_public_path__ + "static/media/visa.a3b570a7.jpg";